import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Nav, Tab } from 'react-bootstrap';
import LottoWheelSelector from './LottoWheelSelector';
import LottoStatisticsPanel from './LottoStatisticsPanel';
import LottoLatestExtraction from './LottoLatestExtraction';
import LottoExtractionHistory from './LottoExtractionHistory';
import './LottoMain.css';

/**
 * Lotto Main Component
 * Aggregates wheel selector, statistics panel, and latest extraction
 * Serves as the main container for the Lotto lottery module
 */
const LottoMain = () => {
  const { t } = useTranslation();
  const [selectedWheel, setSelectedWheel] = useState(null);
  const [activeTab, setActiveTab] = useState('statistics');

  const handleWheelSelected = (wheel) => {
    setSelectedWheel(wheel);
  };

  return (
    <div className="container mt-5">
      {/* Lotto Header */}
      <div className="lottery-header mb-4 lotto-header">
        <h1>{t('titlePageTabLotto')}</h1>
        <p className="mb-0 mt-2" style={{ fontSize: '0.95rem', opacity: 0.95 }}>
          {t('lottoDescription')}
        </p>
      </div>

      <div className="card shadow-lg">
        <div className="card-body p-4">
          {/* Wheel Selector */}
          <div className="lotto-wheel-section mb-4">
            <LottoWheelSelector
              onWheelSelected={handleWheelSelected}
              selectedWheel={selectedWheel}
            />
          </div>

          {/* Tabbed Interface */}
          {selectedWheel && (
            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <div className="card-header border-bottom mb-3">
                <Nav variant="tabs" className="nav-fill">
                  <Nav.Item>
                    <Nav.Link eventKey="statistics" className="fw-600">
                      <i className="bi bi-graph-up"></i> {t('statistics')}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="history" className="fw-600">
                      <i className="bi bi-clock-history"></i> {t('extractionHistory')}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>

              <Tab.Content>
                {/* Statistics Tab */}
                <Tab.Pane eventKey="statistics">
                  {/* Latest Extraction */}
                  <div className="lotto-extraction-section mb-4">
                    <LottoLatestExtraction selectedWheel={selectedWheel} />
                  </div>

                  {/* Statistics Panel */}
                  <div className="lotto-statistics-section">
                    <LottoStatisticsPanel selectedWheel={selectedWheel} />
                  </div>
                </Tab.Pane>

                {/* History Tab */}
                <Tab.Pane eventKey="history">
                  <LottoExtractionHistory selectedWheel={selectedWheel} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          )}
        </div>
      </div>
    </div>
  );
};

export default LottoMain;
